export { default } from '@/views/Jobs';
